import { useDateFormat } from 'hooks/useDateFormat'
import { DateFormatWithTime } from 'types/common/dates'

export const useDateWithTimeFormat = () => useDateFormat(DateFormatWithTime)
